export function normalize(str: string) {
  return str.toLowerCase().replace(/\s+/g, '');
}
